import { createFileRoute } from '@tanstack/react-router';
import { RedirectsPage } from '@pages/redirects';

export const Route = createFileRoute('/_shell/redirects')({ component: RedirectsPage });
